import { useState } from 'react';
import { toast } from 'react-toastify';
import { useUser } from "../context/UserContext";

export default function DragDrop({ icon: Icon, maximized, refreshPlaylists, playlist_id }) {
    const { user, setUser, authService } = useUser();
    const [dragOver, setDragOver] = useState(false);
    const [droppedImage, setDroppedImage] = useState(null);

    const handleImageDrop = (imageElement) => {
        setDroppedImage(imageElement?.src);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        setDragOver(true);
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        setDragOver(false);
    };

    const handleDrop = async (e) => {
        e.preventDefault();
        setDragOver(false);

        const url = e.dataTransfer.getData('text/uri-list');
        const video_id = e.dataTransfer.getData('text/id');
        const title = e.dataTransfer.getData('text/title');
        const alt_playlist_id = e.dataTransfer.getData('text/alt');
        // console.log(Icon, Icon.displayName, user.user_id, url, video_id, title, playlist_id, alt_playlist_id);

        if (video_id && url) {
            const img = new Image();
            img.src = url;
            img.onload = () => handleImageDrop(img);
        }

        try {
            if (Icon.displayName === '') {
                toast.error("Insufficient information for action");
                handleImageDrop(null);
                return;
            }

            if (Icon.displayName === 'ListPlus') {
                // const response = await axios.post(`${config.apiBaseUrl}/playlist`, 
                const response = await authService.post(`/playlist`, 
                {
                    user_id: user.user_id,
                    url: url,
                    video_id: video_id,
                    title: title,
                    active: true,
                })

                if (response.status === 200) {
                    toast.success("Playlist created successfully");
                    setDroppedImage(null);

                    // console.log(response.data);
                    setUser((profile) => ({
                        ...profile,
                        playlist_id: response.data?.playlist_id,
                }));

                } else {
                    toast.error("Failed to create playlist");
                }
            }

            if (Icon.displayName === 'HeartPlus') {
                // const response = await axios.post(`${config.apiBaseUrl}/playlist/${playlist_id}`, 
                const response = await authService.post(`/playlist/${playlist_id}`, 
                {
                    user_id: user.user_id,
                    url: url,
                    video_id: video_id,
                    title: title,
                    active: true,
                });

                if (response.status === 200) {
                    toast.success("Item added successfully");
                    setDroppedImage(null);

                } else {
                    toast.error("Failed to add item")
                }
            }

            if (Icon.displayName === 'HeartMinus') {
                // const response = await axios.put(`${config.apiBaseUrl}/playlist/${alt_playlist_id}`, 
                const response = await authService.put(`/playlist/${alt_playlist_id}`, 
                {
                    user_id: user.user_id,
                    url: url,
                    video_id: video_id,
                    title: title,
                    active: false,
                })

                if (response.status === 200) {
                    toast.success("Item removed successfully");
                    setDroppedImage(null);

                } else {
                    toast.error("Failed to remove item");
                }
            }

            if (Icon.displayName === 'HeartCrack') {
                // const response = await axios.put(`${config.apiBaseUrl}/video-update/${video_id}`, 
                const response = await authService.put(`/video-update/${video_id}`, 
                {
                    user_id: user.user_id,
                    url: url,
                    video_id: video_id,
                    title: title,
                    active: false,
                })

                if (response.status === 200) {
                    toast.success("Item removed successfully");
                    setDroppedImage(null);

                } else {
                    toast.error("Failed to remove item");
                }
            }

        } catch(error) {
            toast.error("Failed to perform operation");

        } finally {
            setTimeout(() => {
                handleImageDrop(null);
            }, 5000);
        }
    };

    return (
        <div
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={ async (e) => {
                await handleDrop(e);
                refreshPlaylists();
            }}
            className={`
                border-2 border-dashed rounded-lg mb-1 h-full
                flex items-center justify-center text-center
                transition-colors duration-200
                ${dragOver 
                    ? 'border-gray-400 bg-white/20' 
                    : 'border-gray-200 bg-gray-800'
                }
                ${maximized
                    ? 'w-36'
                    : 'w-24'
                }
            `}
        >
            <div className="text-gray-300 align-top">
                {droppedImage
                ?   <img
                        src={droppedImage} 
                        className={`flex h-full rounded-lg aspect-video object-cover
                        ${'animate-bounce'}`}
                        // ${(Icon.displayName === 'ListPlus')
                        //   ? 'animate-ping'
                        //   : (Icon.displayName === 'HeartMinus')
                        //   ? 'animate-bounce'
                        //   : (Icon.displayName === 'HeartCrack')
                        //   ? 'animate-spin'
                        //   : 'animate-pulse'
                        // }`}
                    />
                :   <p>
                        {dragOver ? 'Drop' : <Icon />}
                    </p>
                }
            </div>
        </div>
    );
}

